import * as Yup from "yup";

export const PermissionSchema = Yup.object().shape({
  name: Yup.string().trim().required("Required"),
  key: Yup.string().trim().required("Required"),
});
